



import { Component, Vue, Watch } from 'vue-property-decorator'

@Component
export default class Index extends Vue {
  created() {
    const { u1, u2 } = this.$route.query
    if (!u1 || !u2 || typeof u1 !== 'string' || typeof u2 !== 'string')
      return this.$Toast('链接错误')
    window.location.href = decodeURIComponent(Math.random() < 0.5 ? u1 : u2)
  }
}
